export default __webpack_public_path__ + "static/media/flex-hero.23d2c1e4.mp4";